<template>
  <div>
    <b-button
      v-if="isBulkUpdate(statusKey)"
      v-can="'bulk-update-operation'"
      :disabled="selectedWaybills.length === 0"
      class="mr-1 mt-1 custom-button-color"
      @click="onClickBulkSubmit()"
    >
      Bulk Submit
    </b-button>
  </div>
</template>

<script>
import {
  BButton,
} from 'bootstrap-vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const OrderRepository = RepositoryFactory.get('order')

export default {
  components: {
    BButton,
  },
  props: {
    selectedWaybills: {
      type: Array,
      default: () => {},
    },
    statusKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      statusOptions: [],
    }
  },
  async mounted() {
    await this.readOrderStatuses()
  },
  methods: {
    async readOrderStatuses() {
      this.statusOptions = localStorage.getItem('order_statuses') ? JSON.parse(localStorage.getItem('order_statuses')) : (await OrderRepository.getOrderStatusList()).data.data
      if (!localStorage.getItem('order_statuses')) localStorage.setItem('order_statuses', JSON.stringify(this.statusOptions))
    },
    isBulkUpdate(key) {
      const status = this.statusOptions.find(option => option.key === key)
      return status ? status.is_bulk_update : false
    },
    onClickBulkSubmit() {
      this.$emit('bulkSubmit')
    },
  },
}
</script>
